import React from 'react';
import './Pagination.css';

const Pagination = ({ page, totalPages, totalItems, itemLabel = 'items', onPageChange }) => {
  if (totalItems <= 0) return null;

  return (
    <div className="lib-pagination">
      <div className="lib-pagination__info">
        Page <strong>{page}</strong> of <strong>{totalPages}</strong>
        <span> · {totalItems} {itemLabel}</span>
      </div>

      <div className="lib-pagination__nav">
        <button
          type="button"
          className="lib-page-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
        >
          <i className="fas fa-chevron-left" />
          Previous
        </button>

        <button
          type="button"
          className="lib-page-btn"
          disabled={page >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        >
          Next
          <i className="fas fa-chevron-right" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
